export default new class CatalogNavMobile {
    constructor() {
        /* selectors */
        this.categoryTitleMobSelector = '.mobile-category__category-title';

        /* css classes */
        this.openCategoryClass = '_open-category';
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $(document)
            .on('click', this.categoryTitleMobSelector, (e) => {
                e.preventDefault();

                let $mobileCategoryItem = $(e.currentTarget).parent();

                $($mobileCategoryItem).toggleClass(this.openCategoryClass);
            });
    }
};


// WEBPACK FOOTER //
// ./src/common/modules/mobile-category/mobile-category.js